import { getApiActionTypesValues } from '../redux_utils';

export const updateApplicationStatus = (
  applicationId,
  unitId,
  application,
) => ({
  types: getApiActionTypesValues('UPDATE_APPLICATION'),
  promise: ({ client }) =>
    client.put(
      `/residents/applications/${applicationId}/units/${unitId}`,
      application,
    ),
});
